// Route params
export const ROUTE_PARAM_COUNTRY_SLUG = 'countrySlug';
export const ROUTE_PARAM_CITY_SLUG = 'citySlug';
export const ROUTE_PARAM_HOTEL_SLUG = 'hotelSlug';
export const ROUTE_PARAM_BRAND_SLUG = 'brandSlug';

// Path routes
export const ROUTE_PATH_HOTEL = `:${ROUTE_PARAM_BRAND_SLUG}/:${ROUTE_PARAM_COUNTRY_SLUG}/:${ROUTE_PARAM_CITY_SLUG}/:${ROUTE_PARAM_HOTEL_SLUG}`;
export const ROUTE_PATH_MEETING_ROOMS = 'meeting-room';
export const ROUTE_PATH_GUEST_ROOMS = 'guest-rooms';
export const ROUTE_PATH_FLOORPLAN = 'floorplan';
export const ROUTE_PATH_HOTEL_CHAIN_DOLLHOUSE = `dollhouse`;
export const ROUTE_PATH_DOLLHOUSE = `${ROUTE_PATH_HOTEL_CHAIN_DOLLHOUSE}/:${ROUTE_PARAM_HOTEL_SLUG}`;

// Absolute routes
export const ROUTE_ABS_ROOT = '/';
export const ROUTE_ABS_HOTEL = `/${ROUTE_PATH_HOTEL}`;
export const ROUTE_ABS_HOTEL_GUEST_ROOMS = `${ROUTE_ABS_HOTEL}/${ROUTE_PATH_GUEST_ROOMS}`;
export const ROUTE_ABS_DOLLHOUSE = `/${ROUTE_PATH_HOTEL_CHAIN_DOLLHOUSE}`;
export const ROUTE_ABS_DOLLHOUSE_FLOORPLAN = `/${ROUTE_PATH_DOLLHOUSE}/${ROUTE_PATH_MEETING_ROOMS}/${ROUTE_PATH_FLOORPLAN}`;
